import React from 'react';
import RootComponent from './routers/root-component';
function App() {
  return <RootComponent />;
}

export default App;
